import { 
    Box, 
    Typography, 
    Button,
    IconButton,
    Tooltip,
    LinearProgress,
    CircularProgress 
} from '@mui/material';
import * as Icons from '@mui/icons-material';
import { useCurrentHashStore } from '../../stores/hashs/useCurrentHashStore';
import { useAvailableLinesStore } from '../../stores/hashs/useAvailableLinesStore';
import { availableLinesConfig } from '../../utils/hashs/hashConfig';
import { useLoadingStore, selectIsMainLoading } from '../../stores/useLoadingStore';
import { useDateStore } from '../../stores/useDateStore';
import ProfilesBtn from './ProfilesBtn';

export default function AvailableLinesButton({ isCompactMode }) {

    const currentDayShortLabel = useDateStore(state => state.currentDayShortLabel);

    const nextDayShortLabel = useDateStore(state => state.nextDayShortLabel);

    const IconComponent = Icons[availableLinesConfig.icon] || Icons.Warning;

    const setCurrentHash = useCurrentHashStore(state => state.setCurrentHash);

    const currentHash = useCurrentHashStore(state => state.currentHash);

    const loading = useLoadingStore(state => state.loading);

    const loadProgress = useLoadingStore(state => state.loadProgress);

    const isMainLoading = useLoadingStore(selectIsMainLoading);

    const isActive = (currentHash === availableLinesConfig.hash);

    const insideVariant = (availableLinesConfig.variant === 'outlined' ? 'contained' : 'outlined');

    const data = useAvailableLinesStore(state => state.data);
    const total = useAvailableLinesStore(state => state.total);
    const totalToday = useAvailableLinesStore(state => state.totalToday);
    const totalNext = useAvailableLinesStore(state => state.totalNext);
    const title = useAvailableLinesStore(state => state.title);    

    if (isCompactMode) {

        return (
            <Tooltip
                placement="right"
                arrow
                title={
                    <Box>
                        <Typography
                            variant="subtitle2"
                            fontWeight="bold"
                            mb={0.5}
                        >
                            {title}
                        </Typography>

                        <Typography variant="body2">
                            Todas: <strong>{total}</strong>
                        </Typography>

                        <Typography variant="body2">
                            {currentDayShortLabel}: <strong>{totalToday}</strong>
                        </Typography>

                        <Typography variant="body2">
                            {nextDayShortLabel}: <strong>{totalNext}</strong>
                        </Typography>
                    </Box>
                }
            >
                <Box
                    sx={{
                        position: 'relative',
                        width: 46,
                        height: 46,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                >
                    {isMainLoading && (
                        <CircularProgress
                            variant="determinate"
                            value={loadProgress ?? 0}
                            color={availableLinesConfig.color}
                            size={46}
                            thickness={4}
                            sx={{
                                position: 'absolute',
                                top: 0,
                                left: 0
                            }}
                        />
                    )}

                    <IconButton
                        color={availableLinesConfig.color}
                        disabled={loading}
                        onClick={() =>
                            setCurrentHash(
                                availableLinesConfig.hash
                            )
                        }
                        sx={{
                            width: 40,
                            height: 40,

                            border: 2,
                            borderStyle: 'solid',
                            borderColor:
                                `${availableLinesConfig.color}.main`,

                            bgcolor: isActive
                                ? `${availableLinesConfig.color}.main`
                                : 'background.paper',

                            color: isActive
                                ? `${availableLinesConfig.color}.contrastText`
                                : `${availableLinesConfig.color}.main`,

                            boxShadow: 2,

                            transform: isActive
                                ? 'scale(1.08)'
                                : 'scale(1)',

                            transition:
                                'all 0.2s ease-in-out',

                            '&:hover': {
                                bgcolor:
                                    `${availableLinesConfig.color}.main`,
                                color:
                                    `${availableLinesConfig.color}.contrastText`,
                                transform: 'scale(1.08)'
                            }
                        }}
                    >
                        <IconComponent
                            sx={{
                                fontSize: 27
                            }}
                        />
                    </IconButton>
                </Box>
            </Tooltip>
        );

    }

    return (
        <Button
            sx={{
                borderRadius: 1,
                paddingX: 1.5,
                display: 'flex',
                flexDirection: 'column',
                flexBasis: {
                    xs: '100%',
                    md: availableLinesConfig.width,
                },
                alignItems: 'flex-start',
                justifyContent: 'space-between',
                textAlign: 'left',
                position: 'relative',

                borderWidth:
                    insideVariant === 'outlined' ? 3 : 0,
                borderStyle:
                    insideVariant === 'outlined'  ? 'solid' : 'none',

                transform: isActive ? 'scale(1.05)' : 'scale(1)',
                transition: 'transform 0.2s ease-in-out',
                transformOrigin: 'center center'
            }}
            variant={insideVariant}
            color={availableLinesConfig.color}
            loading={loading}
            onClick={() => setCurrentHash(availableLinesConfig.hash)}
        >
        
            {/* PROGRESSO */}
            {isMainLoading && (
                <LinearProgress
                    variant="determinate"
                    value={loadProgress ?? 0}
                    color={availableLinesConfig.color}
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        width: '100%',
                        height: 4
                    }}
                />
            )}
            <Box
                sx={{
                    width: '100%',
                    display: 'flex',
                    gap: .5,
                    alignItems: 'center',
                    marginBottom: 1
                }}
            >
                <IconComponent sx={{ fontSize: 24 }} />
                <Typography variant="body2">
                    <strong>{title}</strong>
                </Typography>
            </Box>

            <ProfilesBtn
                data={data}
                total={total}
            />

            {!isMainLoading && (
                <Box
                    sx={{
                        width: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        paddingTop: 1,
                        borderTop: 2,
                        marginTop: 1,
                        gap: 0
                    }}
                >
                    <Box
                        sx={{
                            px: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: 0,
                            bgcolor: `${availableLinesConfig.color}.main`,
                            color: `${availableLinesConfig.color}.contrastText`,
                            borderRadius: 1
                        }}
                    >
                        <Typography variant="h4" fontWeight="300">{total}</Typography>
                        <Typography sx={{marginTop: -1}} variant="subtitle2" fontWeight="300">TODAS</Typography>
                    </Box>

                    <Box
                        sx={{
                            px: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: 0,
                            bgcolor: 'success.main',
                            color: 'success.contrastText',
                            borderRadius: 1
                        }}
                    >
                        <Typography variant="h4" fontWeight="300">{totalToday}</Typography>
                        <Typography sx={{marginTop: -1}} variant="subtitle2" fontWeight="300">{currentDayShortLabel}</Typography>
                    </Box>

                    <Box
                        sx={{
                            px: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: 0,
                            bgcolor: 'warning.main',
                            color: 'warning.contrastText',
                            borderRadius: 1
                        }}
                    >
                        <Typography variant="h4" fontWeight="300">{totalNext}</Typography>
                        <Typography sx={{marginTop: -1}} variant="subtitle2" fontWeight="300">{nextDayShortLabel}</Typography>
                    </Box>
                </Box>
            )}
        </Button>
    );

}